// src/features/services/media/components/Dashboard_media.tsx
import React, { useEffect } from 'react';
import { useAuth } from '@/shared/auth';
import YoutubeSplitPanel from './YoutubeSplitPanel';
import AudioLibraryPlayer from './AudioLibraryPlayer';

// Placeholder future imports (APIs, tables, widgets)
// import { listMediaItems } from '../api/media';
// import MediaTable from './MediaTable';

const Dashboard_media: React.FC = () => {
  const { can } = useAuth();

  // Set tab title while in Media
  useEffect(() => {
    const prev = document.title;
    document.title = 'PACMaster - Media';
    return () => { document.title = prev; };
  }, []);

  if (!can('media.view')) {
    return (
      <section className="p-6">
        <div className="rounded-lg bg-red-950/40 p-4 text-red-300">
          You do not have permission to view the Media module.
        </div>
      </section>
    );
  }

  return (
  <section className="pt-1 md:pt-2 px-2 md:px-3 pb-2 md:pb-3 space-y-2 h-full min-h-0 flex flex-col">
      <header />
      <div className="flex-1 min-h-0">
        <AudioLibraryPlayer />
      </div>
    </section>
  );
};

export default Dashboard_media;
